export default "__VITE_ASSET__MScN8ueo__"